import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { CpAgGridService } from '@app/Modules/cp-grid/services/cp-ag-grid-service';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';

@Component({
  selector: 'kcfile-edit-error-line',
  templateUrl: './kcfile-edit-error-line.component.html',
  styleUrls: ['./kcfile-edit-error-line.component.scss']
})

export class KcfileEditErrorLineComponent implements AgRendererComponent, OnInit {

  params: any;
  isInternalUser: boolean = false;
  isGlobalUser: boolean = false;
  region: string;
  taxIdProdIdError: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appServ: AppService,
    private cpAgGridService: CpAgGridService,
    private globalAppService: GlobalAppService
  ) {
  }

  agInit(params: any) {
    this.params = params;
  }

  ngOnInit() {
    this.isInternalUser = this.appServ.isInternalUser;
    this.isGlobalUser = this.appServ.isGlobalUser;
    this.region = this.globalAppService.getDefaultRegionString();
    this.isTaxIdProdIdError();
  }
  refresh(params: any): boolean {
    return true;
  }

  kcfileValidationErrors() {
    let fileDetails = this.cpAgGridService.getKcFileErrorData().fileDetails;
    let errorDataArray = this.cpAgGridService.getKcFileErrorData().errorData;
    errorDataArray = errorDataArray.filter(item => {
      return !item.isDeleted;
    });
    let Obj = {
      "errorData": errorDataArray,
      "fileDetails": fileDetails
    }
    let rawErrorData = Object.assign({}, Obj, { "currentErrorLine": this.params.data.line });
    this.router.navigate([{ outlets: { editModalDialog: ['editModal'] } }], { relativeTo: this.activatedRoute, state: { 'fileErrorData': rawErrorData }, queryParamsHandling: "preserve" });
  }

  isTaxIdProdIdError() {
    if (this.region == "LAO" && this.params.data) {
      let findErrorCell = this.params.data.lineErrors.find(item => {
        if ((item.fieldName).toUpperCase() === ("taX_ID").toUpperCase() || (item.fieldName).toUpperCase() === ("proD_ID").toUpperCase()) {
          this.taxIdProdIdError = true;
          return true;
        }
      });
    } else {
      this.taxIdProdIdError = false;
    }
  }
}
